import React from 'react';

interface IRadioSelect {
    options: string[];
    onChange: (event: React.ChangeEvent<HTMLElement>) => void;
    value: string;
    name: string;
    isDisplayInline: boolean;
}

const RadioSelect = ({
    options,
    onChange,
    value,
    name,
    isDisplayInline,
}: IRadioSelect) => {
    return (
        <div className="col-md-12">
            {options.map((option) => {
                return (
                    <label
                        className={`checkbox${
                            isDisplayInline ? '-inline' : ''
                        }`}
                        style={{ marginLeft: '30px' }}
                        key={option}
                    >
                        <input
                            type="checkbox"
                            name={name}
                            value={option}
                            checked={value === option}
                            onChange={onChange}
                        />
                        {option}
                    </label>
                );
            })}
        </div>
    );
};

export default RadioSelect;
